import React, { useState } from "react";
import { ReactComponent as CloseSVG } from "../../../assets/close.svg";
import { ReactComponent as MenuSVG } from "../../../assets/menu.svg";
import { ReactComponent as PlusSVG } from "../../../assets/plus.svg";
import { ReactComponent as MinusSVG } from "../../../assets/minus.svg";
import { ReactComponent as AutoSVG } from "../../../assets/auto.svg";
import { ReactComponent as RandomSVG } from "../../../assets/random.svg";
import currencies from '../../helpers/getCurrency'

import {
  OPDarkContainer,
  OPBox,
  OPHeader,
  OPDescription,
  OPDescriptionContainer,
  OPDescriptionBox,
  OPDescriptionIcon,
  MenuBox,
  OPWrapper,
} from "../settings/SettingsStyled";

export default ({
  handleAboveAnim,
  handleSettingsOut,
  handleAbove,
  aboveAnim,
  audio,
  userInfo
}) => {
  const [soundPlayed, setSoundPlayed] = useState(false);
  const [btnAnimation, setBtnAnimation] = useState(false);
  const { curr, maxWin } = userInfo
  return (
    <OPDarkContainer aboveAnim={aboveAnim} isDisabled={soundPlayed}>
      <OPWrapper>
        <OPBox aboveAnim={aboveAnim}>
          <OPHeader aboveAnim={aboveAnim} close={btnAnimation === "close"}>
            <p>Game Rules</p>
            <span
              onAnimationEnd={() => setBtnAnimation(false)}
              onClick={() => {
                setBtnAnimation("close");
                handleAboveAnim(false);
                setSoundPlayed(true);
                audio.goBack();
                setTimeout(() => {
                  handleAbove(false);
                  handleSettingsOut(false);
                });
              }}
            >
              <CloseSVG />
            </span>
          </OPHeader>
          <OPDescription>
            <h3>Mines</h3>
            <p>
              Mines is yet another revolutionary concept of simplicity developed
              by Orbital’s talented team. <br /> This game is highly
              customizable and you can choose the level of difficulty as you see
              fit. <br />
              The number of mines you choose will affect your overall winnings.
              The harder it is to avoid the mines, the bigger your profit will
              be!
            </p>
          </OPDescription>
          <OPDescription>
            <h3>Settings</h3>
            <OPDescriptionContainer>
              <MenuBox width="42px" height="42px">
                <MenuSVG />
              </MenuBox>
              <OPDescriptionBox>
                <p>Settings button</p>
                <p>Press the button to access Settings.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <p>
              <b> Provably Fair</b> – This section grants you the possibility of
              checking the fairness of the game for yourself. <br />
              <br />
              <b> Game Rules</b> – Short Description of the Game. <br />
              <br />
              <b> History </b>– Shows your previous plays and allows you to
              devise new tactics for your next shuffle. <br />
              <br />
              <b> Music</b> - Turn on the unique audio overlay of the game.{" "}
              <br />
              <br />
              <b> Sound </b> – Enable unique action sounds of the game. <br />
              <br />
              <b> Volume Bar </b> – Set the volume.
            </p>
          </OPDescription>
          <OPDescription>
            <h3>Gameplay Customization </h3>
            <p>
              <b>Play Button</b> – Start the game.
              <br />
              <br />
            </p>
            <OPDescriptionContainer>
              <OPDescriptionIcon>2X</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>2x Button</p>
                <p>Doubles your bet instantly.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>1/2</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>1/2 Button</p>
                <p>Divides your bet by half.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <RandomSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>Random Button</p>
                <p>Selects a random sphere on the board for you</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <p>
              <b>Number Of Mines Button</b> – Set the number of mines.
              <br />
              <br />
              <b>Click on Bet Amount</b> – additional betting options.
              <br /> <br />
              Options: <br /> <br />
            </p>
            <OPDescriptionContainer>
              <OPDescriptionIcon>5X</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>5x Button</p>
                <p>Multiply your bet by 5.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <PlusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>+ Button</p>
                <p>Increase amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <MinusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>- Button</p>
                <p>Decrease amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <AutoSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>Quickplay Button</p>
                <p>Switch to quickplay interface.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            Quickplay Options: <br />
            <p>
              <br />
              <b> Number Of Mines </b> – Set the number of mines during gameplay.{" "}
              <br />
              <br />
              <b> Number Of Bets</b> – Set the number of your bets. <br />
              <br />
              <b> On Win </b>- In this field you can input an option to increase
              or decrease the bet percentage after the winning hand.
              <br />
              <br /> <b>On Loss </b>– In this field you can input an option to
              increase or decrease the bet percentage after the losing hand.{" "}
              <br />
              <br />
              <b> Stop On Profit </b>– Enables you to stop quickplay when a
              certain profit number is reached. <br />
              <br /> <b>Stop On Loss</b> - Enables you to stop quickplay when a
              certain amount is lost. <br />
            </p>
            <br />
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <PlusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>+ Button</p>
                <p>Increase amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <MinusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>- Button</p>
                <p>Decrease amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionBox>
              <p>*Max Win Amount is {maxWin}{currencies[curr]} for this game, win above this won't be added to your balance although you can play the game to try and win more for fun although only win amount you  will be awarded will not exceed max win amount.</p>
            </OPDescriptionBox>
          </OPDescription>
        </OPBox>
      </OPWrapper>
    </OPDarkContainer>
  );
};
